import { GrCircleQuestion } from "react-icons/gr";
import ModalInfo from "../../../components/lib/modalInfo";
import { useEffect, useState } from "react";
import ClientService from "../../../rest/clientService";
import CategorySelect from "../../../components/reusables/categorySelect";

const ProductRegisterFormStep2 = ({ formik }) => {
  const [preferences, setPreferences] = useState(null);

  useEffect(() => {
    ClientService.getClientAdminPreferences().then(setPreferences);
  }, []);

  const baseInput =
    "block w-full px-3 py-1.5 text-base text-gray-700 bg-white border border-gray-300 rounded focus:border-blue-600 focus:outline-none";

  const errorText = "text-red-500 text-xs font-medium min-h-[14px]";

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      {/* GRID */}
      <div className="grid lg:grid-cols-2 gap-x-4">
        {/* SKU */}
        <label className="relative space-y-1">
          <div className="flex items-center justify-between">
            SKU
            <ModalInfo
              icon={<GrCircleQuestion />}
              content="Código que facilita a organização dos itens."
            />
          </div>

          <input
            className={`${baseInput} ${
              formik.touched.sku && formik.errors.sku ? "border-red-500" : ""
            }`}
            name="sku"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.sku}
          />

          <p className={errorText}>
            {formik.touched.sku && formik.errors.sku}
          </p>
        </label>

        {/* LIMITE */}
        <label className="relative space-y-1">
          <div className="flex items-center justify-between">
            Aviso de Limite
            <ModalInfo
              icon={<GrCircleQuestion />}
              content="Alerta quando o estoque atingir o limite definido."
            />
          </div>

          <input
            type="number"
            name="limit_warning"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.limit_warning}
            className={`${baseInput} ${
              formik.touched.limit_warning && formik.errors.limit_warning
                ? "border-red-500"
                : ""
            }`}
          />

          <p className={errorText}>
            {formik.touched.limit_warning && formik.errors.limit_warning}
          </p>
        </label>
      </div>

      {/* CATEGORIA */}
      <label className="relative space-y-1">
        <p>Categoria</p>
        <CategorySelect
          name="category"
          value={formik.values.category}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          categories={preferences?.categories}
        />
         <p className={errorText}>
          {formik.touched.category && formik.errors.category}
        </p>
      </label>

      {/* DESCRIÇÃO */}
      <label className="relative space-y-1">
        <div className="flex items-center justify-between">
          Descrição do Produto
          <ModalInfo
            icon={<GrCircleQuestion />}
            content="Visível no app e no gerenciamento."
          />
        </div>

        <textarea
          name="description"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.description}
          className={`${baseInput} ${
            formik.touched.description && formik.errors.description
              ? "border-red-500"
              : ""
          }`}
        />

        <p className={errorText}>
          {formik.touched.description && formik.errors.description}
        </p>
      </label>

      {/* OBSERVAÇÕES */}
      <label className="relative space-y-1">
        <div className="flex items-center justify-between">
          Observações
          <ModalInfo
            icon={<GrCircleQuestion />}
            content="Visível apenas no gerenciamento."
          />
        </div>

        <textarea
          name="observations"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.observations}
          className={`${baseInput} ${
            formik.touched.observations && formik.errors.observations
              ? "border-red-500"
              : ""
          }`}
        />

        <p className={errorText}>
          {formik.touched.observations && formik.errors.observations}
        </p>
      </label>

      {/* CHECKBOXES */}
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            name="active"
            checked={formik.values.active}
            onChange={formik.handleChange}
            className="w-4 h-4 accent-blue-600"
          />
          <span className="text-sm text-gray-700">
            Ativar produto no cardápio
          </span>
        </label>

        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            name="needsPreparation"
            checked={formik.values.needsPreparation}
            onChange={formik.handleChange}
            className="w-4 h-4 accent-blue-600"
          />
          <span className="text-sm text-gray-700">
            Precisa de preparo pela cozinha
          </span>
        </label>
      </div>
    </div>
  );
};

export default ProductRegisterFormStep2;
